import { SpanProperties } from '../../../../span-progress-app/span-progress-entities';

export const getAccommodationMethod = (id: number): string => {
  switch (id) {
    case 2:
    case 3:
      return 'spanAccomodationMethod.unknown';
    case 5:
    case 6:
      return 'spanAccomodationMethod.direct';
    case 8:
    case 9:
      return 'spanAccomodationMethod.softDigging';
    case 11:
    case 12:
      return 'spanAccomodationMethod.hammerDrilling';
    case 14:
    case 15:
      return 'spanAccomodationMethod.groundRocket';
    case 17:
    case 18:
      return 'spanAccomodationMethod.chainDigging';
    case 20:
    case 21:
      return 'spanAccomodationMethod.microTrenching';
    case 23:
    case 24:
      return 'spanAccomodationMethod.plowing';
    case 26:
    case 27:
      return 'spanAccomodationMethod.slotting';
    case 29:
    case 30:
      return 'spanAccomodationMethod.guidedDrilling';
    case 32:
    case 33:
      return 'spanAccomodationMethod.pressing';
    case 35:
    case 36:
      return 'spanAccomodationMethod.moving';
    case 38:
    case 39:
      return 'spanAccomodationMethod.manualMoving';
    case 41:
    case 42:
      return 'spanAccomodationMethod.clamping';
    case 44:
    case 45:
      return 'spanAccomodationMethod.clampingOnRock';
    case 47:
    case 48:
      return 'spanAccomodationMethod.clampingOnLadder';
    case 50:
    case 51:
      return 'spanAccomodationMethod.existing';
    default:
      return '-';
  }
};

export const getAccommodationType = (id: number): string => {
  switch (id) {
    case 53:
    case 54:
      return 'spanAccomodationType.unknown';
    case 56:
    case 57:
      return 'spanAccomodationType.ground';
    case 59:
    case 60:
      return 'spanAccomodationType.asphalt';
    case 62:
    case 63:
      return 'spanAccomodationType.tunnel';
    case 65:
    case 66:
      return 'spanAccomodationType.bridge';
    case 68:
    case 69:
      return 'spanAccomodationType.radioLink';
    case 71:
    case 72:
      return 'spanAccomodationType.air';
    case 74:
    case 75:
      return 'spanAccomodationType.lake';
    case 369:
      return 'spanAccomodationType.field';
    case 368:
    case 370:
      return 'spanAccomodationType.gravel';
    default:
      return '-';
  }
};

export const getUniqueAccommodationMethodsFromSpanProperties = (
  spanProperties: SpanProperties[],
): string[] => [
  ...new Set(
    spanProperties.map(({ accommodationMethodId }) =>
      getAccommodationMethod(accommodationMethodId),
    ),
  ),
];

export const getUniqueAccommodationTypesFromSpanProperties = (
  spanProperties: SpanProperties[],
): string[] => [
  ...new Set(
    spanProperties.map(({ accommodationTypeId }) =>
      getAccommodationType(accommodationTypeId),
    ),
  ),
];
